import { Component, input } from '@angular/core';

@Component({
    selector: 'fb-section-card',
    template: `
        <section class="rounded-md bg-surface border border-border">
            @if (title()) {
                <header class="flex flex-wrap items-start justify-between gap-3 px-5 pt-5">
                    <div class="flex flex-col gap-1">
                        <h2 class="font-display font-semibold text-lg text-text">{{ title() }}</h2>
                        @if (description()) {
                            <p class="text-sm text-text-muted">{{ description() }}</p>
                        }
                    </div>
                    <div class="flex items-center gap-2">
                        <ng-content select="[actions]" />
                    </div>
                </header>
            }
            <div class="p-5">
                <ng-content />
            </div>
        </section>
    `
})
export class SectionCardComponent {
    title = input<string>();
    description = input<string>();
}
